import { computed, defineComponent, PropType } from "vue";
import DocLink from "./DocLink";
import OfferUtils, { OfferCodeItem, OfferTariff } from "../utils/OfferUtils";
import { OfferJson } from "../OrderForm";

export default defineComponent({
    components: {
        DocLink,
    },

    template: `
        <div class="OfferBoxDocuments">
            <DocLink v-for="term in terms" :class="{ 'DocLink--dark': isdark }" :title="term.title" :url="term.url" />
        </div>
    `,

    props: {
        offer: { type: Object as PropType<OfferJson>, required: true },
        codeitem: { type: Object as PropType<OfferCodeItem> },

        dark: { type: Boolean, default: null },
    },

    setup(props, ctx) {
        const terms = computed(() => {
            return OfferUtils.getOfferTerms(props.offer, props.codeitem);
        });

        const isdark = computed(() => {
            if (props.dark !== null) {
                return props.dark;
            } else {
                return props.offer.tariff == OfferTariff.G11;
            }
        });

        return {
            terms,
            isdark,
        }
    },
});
